'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClipboard, iconClipboardTag } from '@ni/nimble-components/dist/esm/icons/clipboard';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClipboard };
export { iconClipboardTag };
export const NimbleIconClipboard = wrap(IconClipboard);